import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { PlanAddons, PlanMasterList, ReportListResponse, Settings, AutomationMaster } from '@fitness-force/models';

@Pipe({
  name: 'settingsFilter',
  standalone: true
})
export class SettingsFilterPipe implements PipeTransform {
  constructor() { }

  transform(settings: Settings[], term: string): any {
    //check if the search term is defined
    if (!settings || !term) return settings;
    //return updated setting array
    const result = settings.filter(s => s.name.toLowerCase().includes(term.toLowerCase())
      || s.categories.some(c => c.name.toLowerCase().includes(term.toLowerCase()))
      || s.categories.some(c => c.description.toLowerCase().includes(term.toLowerCase()))
    );
    return result;
  }
}

@Pipe({
  name: 'reportFilter',
  standalone: true
})
export class ReportFilterPipe implements PipeTransform {
  constructor() { }

  transform(reports: ReportListResponse[], term: string): any {
    //check if the search term is defined
    if (!reports || !term) return reports;
    //return updated setting array
    let result = reports.filter(s => s.category.toLowerCase().includes(term.toLowerCase())
      || s.reports.some(c => c.report_key.toLowerCase().includes(term.toLowerCase()))
      || s.reports.some(c => c.report_description.toLowerCase().includes(term.toLowerCase()))
    );
    return result;
  }
}


@Pipe({
  name: 'fevouriteReportFilter',
  standalone: true
})
export class FevouriteReportFilterPipe implements PipeTransform {
  constructor() { }

  transform(reports: any, term: string): any {
    //check if the search term is defined
    if (!reports || !term) return reports;
    //return updated setting array
    const result = reports.filter((s: any) => s.report.report_key.toLowerCase().includes(term.toLowerCase())
      || s.report.report_description.toLowerCase().includes(term.toLowerCase())
    );
    return result;
  }
}

@Pipe({
  name: 'highlight',
  standalone: true
})

export class HighlightSearch implements PipeTransform {
  constructor() { }

  transform(value: any, args: any): any {

    if (!args) {
      return value;
    }
    // Match in a case insensitive maneer
    const re = new RegExp(args, 'gi');
    const match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    const replacedValue = value.replace(re, "<mark>" + match[0] + "</mark>");
    return replacedValue;
  }
}

@Pipe({
  name: 'planFilter',
  standalone: true
})
export class PlanFilterPipe implements PipeTransform {
  constructor() { }

  transform(plan: any, term: any): PlanMasterList[] {
    //check if the search term is defined
    if (!plan || !term) return plan;
    if (!term.filter && !term.serviceTypeFilter) return plan;

    let result = {} as PlanMasterList[];
    if (term.filter && term.serviceTypeFilter) {
      result = plan.filter((s: any) =>
        (
          s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.subscription_category.toLowerCase().includes(term.filter.toLowerCase())
        ) && (
          ((s.recurring_service_catagories) && s.recurring_service_catagories.includes(term.serviceTypeFilter))
          || ((s.non_recurring_service_catagories) && s.non_recurring_service_catagories.includes(term.serviceTypeFilter))
        )
      );
    }
    else if (term.filter) {
      result = plan.filter((s: any) =>
        s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
        || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
        || s.subscription_category.toLowerCase().includes(term.filter.toLowerCase())
      );
    }
    else if (term.serviceTypeFilter) {
      result = plan.filter(
         (s: any) =>
         ((s.recurring_service_catagories) && s.recurring_service_catagories.includes(term.serviceTypeFilter))
        || ((s.non_recurring_service_catagories) && s.non_recurring_service_catagories.includes(term.serviceTypeFilter))
      );
    }
    return result;
  }
}
@Pipe({
  name: 'chargeFilter',
  standalone: true
})
export class ChargeFilterPipe implements PipeTransform {
  constructor() { }

  transform(charge: any, term: any): any[] {
    //check if the search term is defined
    if (!charge || !term) return charge;
    if (!term.filter && !term.chargeTypeFilter) return charge;
    let result = {} as any[];
    if (term.filter && term.chargeTypeFilter) {
      result = charge.filter((s: any) =>
        (
          s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.charge_category_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.charge_category_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
        ) &&
          ((s.charge_category_id) && s.charge_category_id == term.chargeTypeFilter)
      );
    }
    else if (term.filter) {
      result = charge.filter((s: any) =>
        s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
        || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
        || s.charge_category_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
        || s.charge_category_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
      );
    }
    else if (term.chargeTypeFilter) {
      result = charge.filter(
         (s: any) =>
         ((s.charge_category_id) && s.charge_category_id == term.chargeTypeFilter)
      );
    }
    return result;
  }
}


@Pipe({
  name: 'addonFilter',
  standalone: true
})
export class AddonFilterPipe implements PipeTransform {
  constructor() { }

  transform(charge: PlanAddons[], term: any): any[] {
    //check if the search term is defined
    if (!charge || !term) return charge;
    if (!term.filter) return charge;
    let result = {} as any[];
    if (term.filter) {
      result = charge.filter((s: PlanAddons) =>
        (
          s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.service_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.service_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.plan_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
          || s.plan_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
        )
      );
    }
    else if (term.filter) {
      result = charge.filter((s: PlanAddons) =>
      s.name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
      || s.name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
      || s.service_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
      || s.service_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
      || s.plan_name_primary_language.toLowerCase().includes(term.filter.toLowerCase())
      || s.plan_name_secondary_language.toLowerCase().includes(term.filter.toLowerCase())
      );
    }
    return result;
  }
}

@Pipe({
  name: 'clientfilter',
  standalone: true
})
export class ClientFilterPipe implements PipeTransform {
  constructor() { }

  transform(clients: any[], term: string): any {
    //check if the search term is defined
    if (!clients || !term) return clients;
    //return updated setting array
    const result = clients.filter(s => s.name.toLowerCase().includes(term.toLowerCase()) || term.includes(s.id));
    return result;
  }
}


@Pipe({
  name: 'tenantfilter',
  standalone: true
})
export class TenantFilterPipe implements PipeTransform {
  constructor() { }
  transform(tenants: any[], term: string): any {
    //check if the search term is defined
    if (!tenants || !term) return tenants;
    const result = tenants.filter(s => s.name_primary_language.toLowerCase().includes(term.toLowerCase()) 
     || s.name_secondary_language.toLowerCase().includes(term.toLowerCase())
     || term.includes(s.id));
    return result;
  }
}

@Pipe({
  name: 'automationFilter',
  standalone: true
})
export class AutomationFilterPipe implements PipeTransform {
  constructor() { }

  transform(automations: any[], term: string): any {
    // Check if search term is defined
    if (!automations || !term) return automations;

    // Filter and update counts
    return automations.map(category => {
      // Filter events that match the search term
      const filteredEvents = category.events.filter((event: any) => 
        event.friendly_name.toLowerCase().includes(term.toLowerCase()) || 
        event.description.toLowerCase().includes(term.toLowerCase())
      );

      // Only include categories that have matching events or category name matches
      if (filteredEvents.length > 0 || category.category_name.toLowerCase().includes(term.toLowerCase())) {
        return {
          ...category,
          events: filteredEvents,
          count: filteredEvents.length // Update count to reflect filtered results
        };
      }
      return null;
    }).filter(category => category !== null); // Remove categories with no matches
  }
}

@Pipe({
  name: 'automationCategoryFilter',
  standalone: true
})
export class AutomationCategoryFilterPipe implements PipeTransform {
  constructor() { } 

  transform(automations: AutomationMaster[], categoryValue: number): any {
    // Check if automations exist
    if (!automations || categoryValue == null) return automations;
    
    // Return filtered automations by category
    return automations.filter(automation => 
      automation.category === categoryValue
    );
  }
}

@NgModule(
  {
    imports: [
      SettingsFilterPipe,
      ReportFilterPipe,
      FevouriteReportFilterPipe,
      HighlightSearch,
      PlanFilterPipe,
      ChargeFilterPipe,
      AddonFilterPipe,
      ClientFilterPipe,
      TenantFilterPipe,
      AutomationFilterPipe,
      AutomationCategoryFilterPipe
    ],
    exports: [
      SettingsFilterPipe,
      ReportFilterPipe,
      FevouriteReportFilterPipe,
      HighlightSearch,
      PlanFilterPipe,
      ChargeFilterPipe,
      AddonFilterPipe,
      ClientFilterPipe,
      TenantFilterPipe,
      AutomationFilterPipe,
      AutomationCategoryFilterPipe
    ]
  }
)

export class CommmonPipeModule { };
